export default {
  title: '入社決定連絡',
  description: 'ご転職おめでとうございます！',
  description2: 'GitTapでの新たな挑戦を通じて、次のステージへと進まれたことを心より嬉しく思います。これからも求職者の皆さまが素晴らしいご縁に恵まれるよう、いただいたご意見を真摯に受け止め、より良いサービスの提供に努めてまいります。',
  reminders: [
    {
      text: '※Amazon ギフト券の詳細については  <a target="_blank" href="http://amazon.co.jp/giftcard/tc">http://amazon.co.jp/giftcard/tc</a> をご確認ください。'
    },
    {
      text: '※GitTapを退会された場合は無効となります。ギフト券プレゼントまでは退会しないようにご注意ください。'
    },
    {
      text: '※お問い合わせは  <a href="mailto:info@gittap.jp">info@gittap.jp</a> までご連絡ください。'
    }
  ],
  companyName: '会社名',
  startDate: '入社日',
  salary: '給与',
  aboutService: 'GitTapについて',
  interview: {
    label: 'インタビュー',
    description1: 'もしよろしければ、今回の転職とGitTapのユーザビリティについてお話をお伺いさせていただけませんか？',
    description2: '※ご協力いただける方には、取材方法や謝礼について、後日メールを送らせていただきます。'
  },
  placeholder: {
    companyName: '入社する企業名',
    startDate: '入社する予定日',
    salary: '転職先での年収',
    aboutService: 'GitTapのサービスについて、自由に感想をお書きください'
  },
  confirmation: '入力内容の確認'
}
